import { render, staticRenderFns } from "./SchoolClassModal.vue?vue&type=template&id=6af7abad"
import script from "./SchoolClassModal.vue?vue&type=script&lang=js"
export * from "./SchoolClassModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6af7abad')) {
      api.createRecord('6af7abad', component.options)
    } else {
      api.reload('6af7abad', component.options)
    }
    module.hot.accept("./SchoolClassModal.vue?vue&type=template&id=6af7abad", function () {
      api.rerender('6af7abad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/schoolClass/modules/SchoolClassModal.vue"
export default component.exports